import React, { useContext, useState } from 'react'
import { Container, InputContainer, Row } from './styled'
import { Button } from '../../../../components/common/Button'
import { Select } from '../../../../components/common/Select'
import { AlwaysAlertContext } from '../../../../context/context_alwaysAlert'
import api from '../../../../services/api'
import { Modal } from '../../../../components/Modal'
import { Siren } from '@phosphor-icons/react'

type FormData = {
  id_base: string
  id_employee: string
  get_location: boolean
  alert_interval: 0
}

export const AlwaysAlertSideTab = ({ onclick }) => {
  const { baseOptions, setNewAlert, handleCreateAlert } =
    useContext(AlwaysAlertContext)
  const [formData, setFormData] = useState<FormData>({
    id_base: '',
    id_employee: '',
    get_location: false,
    alert_interval: 0,
  })
  console.log(formData)

  const [confirmSendAlert, setsconfirmSendAlert] = useState<boolean>(false)
  const [sendedAlert, setSendedAlert] = useState<boolean>(false)

  const hasBase = () => {
    let baseId = false

    if (formData.id_base !== '') {
      baseId = true
    }

    return baseId
  }

  async function handleCreateEvent() {
    try {
      const alertData = {
        id_base: formData.id_base,
        id_employee: localStorage.getItem('id_employee'),
        get_location: formData.get_location,
        alert_interval: formData.alert_interval,
      }

      console.log('criação', alertData)

      handleCreateAlert(alertData)
    } catch (error) {
      console.log('Error', error)
    }
  }

  return (
    <>
      <Container>
        <span>
          Encaminhe alertas para os funcionários e verifique se ele está atento
          na segurança e escolta da região.
        </span>
        <Row>
          <InputContainer width="40%">
            <Select
              onchange={(e) =>
                setFormData((prevData) => ({
                  ...prevData,
                  id_base: e.target.value,
                }))
              }
              label={{
                title: 'Selecione para que base será encaminhado o alerta',
                htmlFor: '',
                color: '#494949',
                fontSize: '14px',
              }}
              data={baseOptions}
              backgroundcolor="#f7f7f7"
              bordercolor="#cecece"
              // currentOption={baseOptions}
              outlinecolor=""
            />
          </InputContainer>
        </Row>
        <Row>
          <InputContainer width="40%">
            <Select
              currentOption={formData?.get_location ? 'Sim' : 'Não'}
              onchange={(e) => {
                if (e.target.value === 'Sim') {
                  setFormData((prevData) => ({
                    ...prevData,
                    get_location: true,
                  }))
                } else if (e.target.value === 'Não') {
                  setFormData((prevData) => ({
                    ...prevData,
                    get_location: false,
                  }))
                }
              }}
              label={{
                title:
                  'Deseja colher a localização de onde foi enviado o código?',
                htmlFor: '',
                color: '#494949',
                fontSize: '14px',
              }}
              data={[
                { id: 'Sim', value: 'Sim' },
                { id: 'Não', value: 'Não' },
              ]}
              backgroundcolor="#f7f7f7"
              bordercolor="#cecece"
              // currentOption={userAccess}
              outlinecolor=""
            />
          </InputContainer>
        </Row>
        <Row>
          <InputContainer width="40%">
            <Select
              onchange={(e) =>
                setFormData((prevData) => ({
                  ...prevData,
                  alert_interval: parseInt(e.target.value),
                }))
              }
              label={{
                title: 'Defina o intervalo entre os alertas',
                htmlFor: '',
                color: '#494949',
                fontSize: '14px',
              }}
              data={Array.from({ length: 15 }, (_, index) => ({
                id: index + 1,
                value: index + 1,
              }))}
              backgroundcolor="#f7f7f7"
              bordercolor="#cecece"
              // currentOption={userAccess}
              outlinecolor=""
            />
          </InputContainer>
          <span id="minutes">Minutos.</span>
          <span id="warn">
            <span style={{ color: 'red' }}>*</span>
            Após 3 alertas, não será mais aceito o envio.
          </span>
        </Row>
        <InputContainer width="15rem" style={{ alignSelf: 'flex-end' }}>
          <Button.Root
            backgroundColor="#00517D"
            onClick={() => {
              if (!formData.id_base || !formData.alert_interval) {
                return
              }
              setsconfirmSendAlert((prev) => !prev)
            }}
          >
            <Button.Content title="Enviar alerta" color="#fff" />
          </Button.Root>
        </InputContainer>
      </Container>

      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        width="fit-content"
        height="fit-content"
        left="50%"
        top="50%"
        open={confirmSendAlert}
        setIsOpenController={() => setsconfirmSendAlert((prev) => !prev)}
      >
        <Modal.Header onclick={() => setsconfirmSendAlert((prev) => !prev)} />
        <Modal.Content
          value="Você deseja realmente enviar o alerta?"
          subvalue="Ao clicar em enviar, o alerta será encaminhado para todos os seguranças."
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#fff"
            border="1px solid #770A00"
            onClick={() => setsconfirmSendAlert((prev) => !prev)}
          >
            <Button.Content title="Não, cancelar" color="#770A00" />
          </Button.Root>
          <Button.Root
            backgroundColor="#00517D"
            onClick={() => {
              setSendedAlert((prev) => !prev)
              setsconfirmSendAlert((prev) => !prev)
              handleCreateEvent()
            }}
          >
            <Button.Content title="Enviar" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>

      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        height="fit-content"
        width="25%"
        left="50%"
        top="50%"
        open={sendedAlert}
        setIsOpenController={() => setSendedAlert((prev) => !prev)}
      >
        <Modal.Header onclick={() => setSendedAlert((prev) => !prev)} />
        <Modal.Icon icon={<Siren size={60} color="#BB0000" weight="fill" />} />
        <Modal.Content
          value="Alerta Enviado!"
          subvalue="O alerta foi enviado para todos aqueles funcionários que não estão com ocorrências em andamento. Durante o tempo que você definiu eles terão a chance de responder o aviso."
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#00517D"
            onClick={() => location.reload()}
          >
            <Button.Content title="Voltar para página" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>
    </>
  )
}
